import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RecentSearchService } from '@services/recent-search.service';
import { GlobalMessageService, GlobalMessageType, PageLinkService, ProductSearchPage, ProductSearchService } from '@spartacus/core';
import { PageLayoutService, ProductListComponentService, ViewConfig } from '@spartacus/storefront';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { filter, skip, take } from 'rxjs/operators';

@Component({
  selector: 'cx-custom-product-list',
  standalone: false,
  templateUrl: './custom-product-list.component.html',
  styleUrls: ['./custom-product-list.component.scss'],
})
export class CustomProductListComponent {
  private subscription = new Subscription();

  model$: Observable<ProductSearchPage> = this.productListComponentService.model$;
  templateName$: Observable<string> = this.pageLayoutService.templateName$;

  recentSearchService = inject(RecentSearchService);

  constructor(
    private pageLayoutService: PageLayoutService,
    private productListComponentService: ProductListComponentService,
    private globalMessageService: GlobalMessageService,
    public scrollConfig: ViewConfig,
    private productSearchService: ProductSearchService,
    private pageService: PageLinkService,
  ) {}

  pageChange(): void {
    window.scrollTo(0, 0);
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.subscription.add(this.pageLayoutService.templateName$.pipe(take(1)).subscribe((template) => {}));

    this.subscription.add(
      combineLatest([this.model$])
        .pipe(
          skip(1),
          filter(([model]) => !!model)
        )
        .subscribe(() =>
          this.globalMessageService.add({ key: 'sorting.pageViewUpdated' }, GlobalMessageType.MSG_TYPE_ASSISTIVE, 500)
        )
    );
  }

  ngAfterContentChecked(): void {
    this.setPreviousQuery();
  }

  setPreviousQuery(): void {
    const link = this.pageService.getCanonicalUrl();
    const parts = link.split('/');
    const relativeUrl = `/${parts.slice(parts.length - 3).join('/')}`;
    this.recentSearchService.setRecentSearch(relativeUrl);
  }

  router = inject(Router);

  sortList(sortCode: string): void {
    this.productListComponentService.sort(sortCode);
    this.router.navigate([], {
      queryParams: { sortCode: sortCode, currentPage: 0 },
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  results$ = this.productSearchService.getResults();
}
